import React, { useState, useRef , useEffect  } from 'react';
import {Card, Modal} from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import "react-datepicker/dist/react-datepicker.css";
import "tabulator-tables/dist/css/tabulator_semanticui.min.css"; 
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from '../../store.jsx';
import loader from '../../assets/img/loading.gif'
import API from '../../api/api.jsx';
import { clearMenuState, setMenuInfo } from '../../reducers/menuReducers';

// 수수료관리 화면
const Settings001 = () => {
	const dispatch                                     = useDispatch();

	const { t, i18n }                                  = useTranslation();

	// 초기 값
	const userInfo                                     = getUserInfo(store.getState());
	const [loading, setLoading]                        = useState(false);
	const [authorityId, setAuthorityId]     		   = useState(userInfo.authority);
	const [responseData, setResponseData]              = useState([]);
	const [authOption, setFetchAuthorityOptions] 	   = useState([]);
	const [menuAuthorityOption,setMenuAuthorityOption] = useState([]);

	// 각 메뉴의 체크 여부를 관리하기 위한 상태 추가
	const [menuCheckStates, setMenuCheckStates]        = useState({});

	// 각 메뉴의 체크 상태를 업데이트하는 함수
	const handleMenuCheckChange = (menuId) => {
		setMenuCheckStates((prevStates) => ({
			...prevStates,
			[menuId]: !prevStates[menuId],
		}));
	};

	// 권한변경
	const handleChangeAuthorityId = (e) => {
		setAuthorityId(e.target.value);
	};

	// 조회 버튼 작동 시 실행되는 함수
	const handleQuery = async () => {
		setLoading(true);
	
		// API 호출 부분
		try {
			const data = await API.fetchSettings001Data({
				authority_id : authorityId
			});

			// 전달받은 데이터 중 다국어에 따라 Tabulator에 번역이 되어 display되게 하는 부분
			const translatedData = data.map(item => ({
				...item,
				authorityId 	: t(`AUTHORITY.${item.authorityId}`),
			}));

			// 각 메뉴의 체크 상태를 초기화한당.
			const initialCheckStates = {};

			translatedData.forEach((menu) => {
				if (menu.childMenuList && menu.childMenuList.length > 0) {
					menu.childMenuList.forEach((submenu) => {
						initialCheckStates[submenu.menuId] = submenu.checked;
					});
				}
			});

			setMenuCheckStates(initialCheckStates);

			setResponseData(translatedData);
			setLoading(false);
		} catch (error) {
			console.error('Error in fetchSettings001DataUpdateState:', error);
			setLoading(false);
		}
	};

	useEffect(() => {
		const menuAuthorityOptions = async () => {
			try {
				const options = await API.fetchAuthorityOptions({
					params: {
						authority_id : authorityId
					},
				});

				setFetchAuthorityOptions(options);
				setAuthorityId(options.length > 0 ? authorityId : ''); // 첫 번째 옵션으로 authorityId 지정

			} catch (error) {
				console.error('Error fetching fee info options:', error);
			}
		};

		menuAuthorityOptions();
	}, []);

	useEffect(() => {
		// handleQuery를 호출하기 전에 authorityId가 빈 문자열이 아닌지 확인합니다
		if (authorityId !== '' && authorityId !== undefined) {
			handleQuery();
		}
	}, [authorityId]);

	// 데이터 저장시에 useRef 를 통해서 처리
    const formRef = useRef(null);

	// 저장 
	const handleSave = async (e) => {
        e.preventDefault();

		try {
			const savedData = await API.fetchSettings001DataPost({
				responseData    : responseData,
				menuCheckStates : menuCheckStates,
				authority_id    : authorityId,
			});

			if (savedData.code === 200) {
				// redux에 저장된 메뉴정보를 초기화한 후
				dispatch(clearMenuState());

				alert('메뉴 권한 저장 완료');

				// 권한에 따른 메뉴 정보가 바뀜에 따라 메뉴 정보를 다시 redux에 저장
				await API.fetchMenu(userInfo)
					.then(response => {
						dispatch(setMenuInfo(response))
					})
				// handleQuery();
			}
		} catch (error) {
			console.error('메뉴권한 저장 에러:', error);
		}

		try {
			// 수동으로 폼 제출
			formRef.current.submit();
		} catch (error) {
			console.error('수동으로 폼 제출 에러:', error);
			// 폼 제출이 실패했을 때 수행할 로직을 추가하면 됩니다.
		}
    };

	// UI
	return (
		<Card style={{ height: '100%' }}>
			<Card.Header><strong>{t('PREFERENCES.메뉴권한관리', { defaultValue: '메뉴권한관리' })}</strong></Card.Header>
			<Card.Body className='responsive-card-body'>
				<div className="panel-body">
					<div className="row ms-0">
						<div className="form-group col-lg-2 col-md-12 col-xs-12 mb-2 ps-0 rounded-2">
							<label className="form-label" htmlFor="acct_nickname_id">
								<i className="bi bi-pen"></i> {t('PREFERENCES.직원 권한', { defaultValue: '직원 권한' })}
							</label>

							<select
								className="form-select"
								id="fee_type_id"
								onChange={handleChangeAuthorityId}
								value={authorityId}
							>
								{authOption.map((option, index) => (
									<option key={index} value={option.code}>
										{t(`AUTHORITY.${option.code}`, { defaultValue: `${option.code}` })}
									</option>
								))}
							</select>
						</div>

						<div className="form-group col-lg-4 col-md-12 col-xs-12"></div>
						<div className="form-group col-lg-5 col-md-12 col-xs-12"></div>

						<div className="form-group col-lg-1 col-md-12 col-xs-12 ps-0 rounded-2">
							<div className="mb-3"></div>
							<button type="button" className="btn btn-success float-end float-bottom w-100 h-30.5px align-baseline mt-8px" onClick={handleQuery}>{t('LOAN_APPLICATION.조회', { defaultValue: '조회' })}</button>
						</div>
					</div>
				</div>
				
				<div className="card border-1 mb-4">
					<div className="card-body fw-bold">
						<form ref={formRef} onSubmit={handleSave}>
							{responseData.map((menu, index) => (
								<div key={index} className="row form-group mb-6">
									<label className="form-label col-form col-md-3" htmlFor="">
										{t(`MENU_I18N.${menu.menuName}`, { defaultValue: menu.menuName })}
									</label>

									<div className="col-md-9 mb-2">
										{/* checkbox 버전 */}
										{/* {menu.childMenuList && menu.childMenuList.length > 0 && (
											// 대메뉴일 경우 서브메뉴 표시
											menu.childMenuList.map((submenu, subIndex) => (
												<div className="form-check mt-2 mb-2">
													<input 
														key={subIndex} 
														className="form-check-input me-3" 
														type="checkbox" 
														htmlFor="validCheckbox" 
														id={`checkbox_${submenu.menuId}`}
														checked={menuCheckStates[submenu.menuId]}
														onChange={() => handleMenuCheckChange(submenu.menuId)}
													/>
													<label className="form-check-label" htmlFor={submenu.menuId}>
														{t(`MENU.${submenu.menuId}`, { defaultValue: submenu.menuName })}
													</label>
												</div>
											))
										)} */}

										{/* Switch 버전 */}
										{menu.childMenuList && menu.childMenuList.length > 0 && (
											// 대메뉴일 경우 서브메뉴 표시
											menu.childMenuList.map((submenu, subIndex) => (
												// console.log(submenu)
												<div key={subIndex} className="form-switch mt-2 mb-2">
													<input
														key={subIndex}
														className="form-check-input me-3"
														type="checkbox"
														htmlFor={`checkbox_${submenu.menuId}`}
														id={`checkbox_${submenu.menuId}`}
														checked={menuCheckStates[submenu.menuId]}
														onChange={() => handleMenuCheckChange(submenu.menuId)}
													/>
													<label className="form-check-label" htmlFor={`checkbox_${submenu.menuId}`}>
														{t(`MENU_I18N.${submenu.menuName}`, { defaultValue: submenu.menuName })}
													</label>
												</div>
											))
										)}
									</div>
								</div>
							))}
						</form>
					</div>
				</div>
			</Card.Body>

			<div className="card-footer d-flex justify-content-start mt-auto">
				<button type="button" className="btn btn-outline-primary mb-1 me-1 w-100px"  onClick={handleSave}>저장</button>
			</div>
		</ Card>
	);
};

export default Settings001;